var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['task', {'task--done': _vm.task.status === 'DONE'}]},[_c('span',{staticClass:"task__id"},[_vm._v("id: "+_vm._s(_vm.task.id))]),_c('span',{staticClass:"task__text"},[_vm._v(_vm._s(_vm.task.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }